import * as React from "react"
import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import parse from "html-react-parser"

const StyledSection = styled.section`
  position: relative;
  z-index: 1;
  background-color: #fff;
  margin-top: -1rem;
  padding-top: 1rem;

  > .gatsby-image-wrapper:first-of-type {
    position: absolute !important;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;

    img {
      width: auto !important;
    }
  }

  @media (max-width: 756px) {
    background-position: left bottom;
  }
`

const Inner = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1160px;
  padding: 4rem 1rem 0;
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 756px) {
    flex-direction: column-reverse;
  }

  @media (min-width: 757px) {
    .gatsby-image-wrapper {
      flex: 1;
      max-width: 50%;
    }
  }
`

const About = styled.div`
  flex: 1;

  h2 {
    color: #6C7E99;
    margin-bottom: 0.5rem;
  }

  p {
    margin-bottom: 0.75rem;
  }

  p:last-of-type {
    margin-bottom: 2rem;
  }

  @media (max-width: 756px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

const Button = styled(Link)`
  text-decoration: none;
  background-color: #fff;
  background-image: none;
  color: #222a3f;
  border: 2px solid #6C7E99;
  padding: 1rem 2rem;
  font-size: 18px;
  line-height: 1;
  display: inline-block;
  transition: all 0.3s ease-in-out;

  &:hover, &:focus {
    background-color: #6C7E99;
    color: #fff;
  }
`

const ScreenReaderText = styled.span`
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`


const Adam = () => {
  const data = useStaticQuery(graphql`
  query AboutAdam {
    # selecting the current post by id
    fields: wpPage(isFrontPage: { eq: true }) {
      footerSettingsFields {
        aboutAdam {
          heading
          text
          button {
            label
            url
          }
          image {
            node {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 600
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }
    }
  }
  `)

  const aboutAdam = data.fields.footerSettingsFields.aboutAdam;
  const image = aboutAdam.image.node.localFile.childImageSharp.gatsbyImageData;
  return (
  <StyledSection>
    <StaticImage src="../../images/reset/bubbles-left.svg" alt="" objectFit="contain" backgroundColor="#ffffff" placeholder="#ffffff" />
    <Inner>
      <GatsbyImage image={image} alt={aboutAdam.image.node.altText} />
      <About>
        <h2>{aboutAdam.heading}</h2>
        {parse(aboutAdam.text)}
        <Button to="/about">Learn More <ScreenReaderText>about Adam</ScreenReaderText></Button>
      </About>
    </Inner>
  </StyledSection>
)
}

export default Adam
